import { Action } from '@ngrx/store';

export enum AuthActionTypes {
    LoadAuths = '[Auth] Load Auths',
    SetAuths = '[Auth] Set Auths',
    SET_CURRENT_TITLE = '[UI] SET CURRENT TITLE'
}


export class SetCurrentTitle implements Action {
    readonly type = AuthActionTypes.SET_CURRENT_TITLE;
  
    constructor(public payload?: string) {}
  }


export type AuthActions =  SetCurrentTitle;
